import { render, staticRenderFns } from "./SocialMediaAuth.vue?vue&type=template&id=aadb7d68&scoped=true&"
import script from "./SocialMediaAuth.vue?vue&type=script&lang=js&"
export * from "./SocialMediaAuth.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaAuth.vue?vue&type=style&index=0&id=aadb7d68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aadb7d68",
  null
  
)

export default component.exports